
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import QrcodeIcon from "vue-material-design-icons/Qrcode.vue";
import PrinterIcon from "vue-material-design-icons/Printer.vue";
import ContentCopyIcon from "vue-material-design-icons/ContentCopy.vue";
import OpenInNewIcon from "vue-material-design-icons/OpenInNew.vue";
import QrCodeVue from "qrcode.vue";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-restaurante-mesas",
  components: {
    Pencil,
    TrashCanIcon,
    QrcodeIcon,
    PrinterIcon,
    ContentCopyIcon,
    OpenInNewIcon,
    QrCodeVue,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Número",
          field: "numero",
          type: "text",
          sortable: true,
          width: "12%",
        },
        {
          label: "Nome",
          field: "nome",
          type: "text",
          sortable: true,
          width: "20%",
        },
        {
          label: "Ambiente",
          field: "ambiente_nome",
          type: "text",
          sortable: true,
          width: "20%",
        },
        {
          label: "Capacidade",
          field: "capacidade",
          type: "number",
          sortable: true,
          width: "12%",
        },
        {
          label: "Status",
          field: "status",
          type: "text",
          sortable: true,
          slot: true,
          width: "14%",
        },
        {
          label: "Ativo",
          field: "ativo",
          type: "text",
          sortable: true,
          slot: true,
          width: "10%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "12%",
        },
      ],
      qrCodeModalVisible: false,
      qrCodeLoading: false,
      qrCodeData: null,
    };
  },
  methods: {
    statusLabel(status) {
      const labels = {
        livre: "Livre",
        ocupada: "Ocupada",
        reservada: "Reservada",
        inativa: "Inativa",
      };

      return labels[status] || status;
    },
    statusClass(status) {
      const classes = {
        livre: "label label-lg label-inline label-light-success",
        ocupada: "label label-lg label-inline label-light-danger",
        reservada: "label label-lg label-inline label-light-warning",
        inativa: "label label-lg label-inline label-light-dark",
      };

      return classes[status] || "label label-lg label-inline label-light";
    },
    nomeMesa(data) {
      return data.nome ? data.numero + " - " + data.nome : data.numero;
    },
    mesaEditRoute(mesa) {
      if (!this.isAmbienteRoute) {
        return {
          name: "restauranteMesasEditar",
          params: {
            id: mesa.id,
          },
        };
      }

      return {
        name: "restauranteAmbientesMesasEditar",
        params: {
          ambienteId: this.ambienteId,
          id: mesa.id,
        },
        query: {
          ambiente_nome: this.ambienteNome,
        },
      };
    },
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a mesa " + this.nomeMesa(data) + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/restaurante/mesas/delete", {
              id: data.id,
            });

            this.$refs.mesas.refresh();
            this.$toast.success("Mesa excluída!");
          }
        });
    },
    async abrirQrCode(mesa) {
      this.qrCodeData = null;
      this.qrCodeLoading = true;
      this.qrCodeModalVisible = true;

      try {
        const response = await this.$http.get(
          `/restaurante/mesas/${mesa.id}/self-pedido-qr`
        );
        this.qrCodeData = response.data;
      } catch (error) {
        this.qrCodeModalVisible = false;
        this.$toast.error(
          error.response?.data?.msg || "Não foi possível carregar o QR Code."
        );
      } finally {
        this.qrCodeLoading = false;
      }
    },
    async copiarQrCodeUrl() {
      if (!this.qrCodeUrl) {
        return;
      }

      if (this.$copyText) {
        await this.$copyText(this.qrCodeUrl);
      } else {
        await navigator.clipboard.writeText(this.qrCodeUrl);
      }

      this.$toast.success("URL copiada!");
    },
    imprimirQrCode() {
      const printArea = this.$refs.selfPedidoQrPrint;
      const canvas = printArea ? printArea.querySelector("canvas") : null;
      const qrCodeImage = canvas ? canvas.toDataURL("image/png") : "";
      const janela = window.open("", "_blank", "width=480,height=680");

      if (!janela) {
        this.$toast.error("Não foi possível abrir a janela de impressão.");
        return;
      }

      janela.document.write(`
        <!doctype html>
        <html>
          <head>
            <meta charset="utf-8">
            <title>QR Code do Self Pedido</title>
            <style>
              body {
                margin: 0;
                padding: 24px;
                font-family: Arial, sans-serif;
                color: #1f2937;
                text-align: center;
              }
              h1 {
                margin: 0 0 10px;
                font-size: 24px;
              }
              p {
                margin: 6px 0;
                font-size: 15px;
              }
              img {
                width: 260px;
                height: 260px;
                margin: 22px auto 18px;
                display: block;
              }
              .url {
                margin-top: 16px;
                font-size: 12px;
                word-break: break-all;
              }
            </style>
          </head>
          <body>
            <h1>Self Pedido</h1>
            <p><strong>Mesa:</strong> ${this.escapeHtml(
              this.qrCodeMesaTitulo
            )}</p>
            <p><strong>Ambiente:</strong> ${this.escapeHtml(
              this.qrCodeAmbiente || "Não informado"
            )}</p>
            ${
              qrCodeImage
                ? `<img src="${qrCodeImage}" alt="QR Code do Self Pedido">`
                : ""
            }
            <p class="url">${this.escapeHtml(this.qrCodeUrl)}</p>
          </body>
        </html>
      `);
      janela.document.close();
      janela.focus();
      janela.print();
    },
    escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    isAmbienteRoute() {
      return !!(this.$route.query.ambiente_id || this.$route.params.ambienteId);
    },
    ambienteId() {
      return (
        this.$route.query.ambiente_id || this.$route.params.ambienteId || null
      );
    },
    ambienteNome() {
      return this.$route.query.ambiente_nome || "Ambiente";
    },
    tituloTabela() {
      return this.isAmbienteRoute
        ? `Mesas - ${this.ambienteNome}`
        : "Cadastro de Mesas";
    },
    novaMesaUrl() {
      if (!this.isAmbienteRoute) {
        return "/#/restauranteMesas/novo";
      }

      return `/#/restauranteAmbientes/${
        this.ambienteId
      }/mesas/novo?ambiente_nome=${encodeURIComponent(this.ambienteNome)}`;
    },
    secondaryButtonUrl() {
      return this.isAmbienteRoute
        ? "/#/restauranteAmbientes"
        : "/#/restauranteMesas";
    },
    secondaryButtonText() {
      return this.isAmbienteRoute ? "Ambientes" : "Salão";
    },
    tableExtraParams() {
      return this.isAmbienteRoute
        ? {
            ambiente_id: this.ambienteId,
          }
        : {};
    },
    qrCodeUrl() {
      if (!this.qrCodeData) {
        return "";
      }

      if (this.qrCodeData.self_pedido.public_url) {
        return this.qrCodeData.self_pedido.public_url;
      }

      // Compatibilidade durante o deploy ordenado: versões antigas da API
      // ainda retornavam apenas o path. Não inferimos host ou porta; o fallback
      // só é usado quando a origem pública foi configurada explicitamente.
      const configuredBaseUrl = process.env.VUE_APP_SELF_PEDIDO_BASE_URL;

      if (!configuredBaseUrl || !this.qrCodeData.self_pedido.path) {
        return "";
      }

      return `${configuredBaseUrl.replace(/\/+$/, "")}${
        this.qrCodeData.self_pedido.path
      }`;
    },
    qrCodeMesaTitulo() {
      if (!this.qrCodeData) {
        return "";
      }

      const mesa = this.qrCodeData.mesa;

      return mesa.nome ? `${mesa.numero} - ${mesa.nome}` : mesa.numero;
    },
    qrCodeAmbiente() {
      return this.qrCodeData?.mesa?.ambiente?.nome || "";
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
